import {Component, OnInit} from '@angular/core';
import {Observable} from "rxjs";
import {Club} from "../shared/model/club";
import {ClubsService} from "../shared/model/clubs.service";
import {AuthService} from "../shared/security/auth.service";
import {clubData} from "../../../club-data";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {CommandService} from "../shared/model/command.service";

@Component({
    selector: 'app-clubs',
    templateUrl: './clubs.component.html',
    styleUrls: ['./clubs.component.css']
})
export class ClubsComponent implements OnInit {

  clubs$: Observable<Club[]>;
  selectedRow: number;
  searchString: string = "";
  searchString2: string = "";
  role = "";
  distributorCode = 0;

  myForm: FormGroup;

  constructor(private fb: FormBuilder, private clubsService: ClubsService, private authService: AuthService, public commandService: CommandService) {
    this.myForm = fb.group({
      'searchString': [''],
      'searchString2': ['']
    });
    this.role = this.authService.getUserRole();
    this.distributorCode = this.authService.getDistributorCode();

    //console.log(`role: ${this.role}, distributorCode: ${this.distributorCode}`);

    if ( this.distributorCode !== 0 ) {
      this.clubsService.findAllClubsForDistributor( this.distributorCode );
    } else {
      this.clubs$ = this.clubsService.findAllClubs();
    }

  }

  ngOnInit() {
    if ( this.distributorCode !== 0 ) {
      this.clubs$ = this.clubsService.findAllClubsForDistributor(this.distributorCode);
    } else {
      this.clubs$ = this.clubsService.findAllClubs();
    }
  }

  setSelected(row: number, clubId: string) {
      this.selectedRow = row;
      this.authService.setClubDetails(clubId);
  }

  valueClubChanges(newValue) {
    //console.log(`valueClubChanges`);
    if ( this.distributorCode !== 0 ) {
      this.disableDistributorSearch();
      return;
    }

    this.searchString2 = "";
    this.searchString = newValue;
    if ( !newValue ) {
      this.clubs$ = this.clubsService.findAllClubs();
    } else {
      this.clubs$ = this.clubsService.findClubsByName(newValue);
    }

  }

  valueTownChanges(newValue) {
    //console.log(`valueTownChanges`);
    if ( this.distributorCode !== 0 ) {
      this.disableDistributorSearch();
      return;
    }

    this.searchString = "";
    this.searchString2 = newValue;

    if ( !newValue ) {
      this.clubs$ = this.clubsService.findAllClubs();
    } else {
      this.clubs$ = this.clubsService.findClubsByCity(newValue);
    }
  }

  getDistributorCode( code ): string {
    if ( code !== 0 ) {
      return code;
    } else {
      return "-";
    }
  }

  getTenantId( tenantId ): string {
    if ( tenantId !== 0 ) {
      return tenantId;
    }  else {
      return "-";
    }
  }

  getDemo( demo: boolean ): string {
    if ( demo ) {  // demo license (i.e. no license!)
      return "False";
    }  else {
      return "True";
    }
  }

  disableDistributorSearch() {
    this.myForm.controls['searchString'].disable();
    this.myForm.controls['searchString2'].disable();
    this.clubs$ = this.clubsService.findAllClubsForDistributor(this.distributorCode);
  }

  toggleDemo( clubId: string, demo: boolean ) {
    let d = -1;
    if ( demo ) {
      d = 0;
    } else {
      d = 1;
    }
    //console.log(`setdemo(): demo: ${demo}, inverse: ${d}`);
    this.commandService.addCommand(clubId,"", "", null, "DB_SET_DEMO", d, false, "", this.authService.getUserName());
  }
}
